<template>
  <b-card>
    <validation-observer ref="simpleRules" #default="{ invalid }">
      <!-- form -->
      <b-form>
        <b-row>
          <!-- old password -->
          <b-col md="6">
            <b-form-group
              label="Password Anterior"
              label-for="account-old-password"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="account-old-password"
                  v-model="passwordValueOld"
                  autofocus
                  name="old-password"
                  :type="passwordFieldTypeOld"
                  placeholder="Old Password"
                  @blur="checkPassword"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIconOld"
                    class="cursor-pointer"
                    @click="togglePasswordOld"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col v-if="isPasswordChecked!==null" md="6">
            <b-spinner class="mt-2 spinner-avatar" small :variant="isPasswordChecked ? 'info' : 'danger'" type="grow">
            </b-spinner>
            <p>{{ isPasswordChecked ? 'Password correcto, continua' : 'El password no coincide' }}</p>
          </b-col>
        <!--/ old password -->
        </b-row>
        <b-row>
          <!-- new password -->
          <b-col md="6">
            <b-form-group
              label-for="account-new-password"
              label="New Password"
            >
              <validation-provider #default="{ errors }" name="new-password" :rules="pwdRules">
                <b-input-group class="input-group-merge">
                  <b-form-input
                    id="account-new-password"
                    v-model="newPasswordValue"
                    :type="passwordFieldTypeNew"
                    name="new-password"
                    placeholder="New Password"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordToggleIconNew"
                      class="cursor-pointer"
                      @click="togglePasswordNew"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!--/ new password -->

          <!-- retype password -->
          <b-col md="6">
            <b-form-group
              label-for="account-retype-new-password"
              label="Retype New Password"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="account-retype-new-password"
                  v-model="RetypePassword"
                  :type="passwordFieldTypeRetype"
                  name="retype-password"
                  placeholder="New Password"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIconRetype"
                    class="cursor-pointer"
                    @click="togglePasswordRetype"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <!--/ retype password -->

          <!-- buttons -->
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-1 mr-1"
              :disabled="invalid || $apiCall.state"
              @click="changePassword"
            >
              Change
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="reset"
              variant="outline-secondary"
              class="mt-1"
            >
              Reset
            </b-button>
            <b-form-checkbox
              id="pwdSwitchChgPwd"
              v-model="strongPwd"
              class="ml-2"
              name="check-button"
              switch
              inline
            >
              <span>Strong Password</span>
            </b-form-checkbox>
          </b-col>
        <!--/ buttons -->
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BFormCheckbox, BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup, BInputGroupAppend, BSpinner
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver/*, localize */} from 'vee-validate'
import { required, email, max, min, password } from '@validations'

// localize('es')

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    BSpinner,
    BFormCheckbox,

    ValidationProvider,
    ValidationObserver
  },
  directives: {
    Ripple
  },
  props:{
    storeType: {
      type: String,
      default: 'userStore'
    }
  },
  data() {
    return {
      strongPwd: true,
      passwordValueOld: '',
      newPasswordValue: '',
      RetypePassword: '',
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
      isPasswordChecked: null,

      // validations
      required,
      email,
      max,
      min,
      password
    }
  },
  computed: {
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    pwdRules() {
      return `required|min:5|${this.strongPwd ? 'password' : ''}`
    }
  },
  methods: {
    togglePasswordOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password'
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
    checkPassword() {
      this.$store.dispatch(`${this.storeType}/checkPassword`, this.passwordValueOld)
        .then(val => {
          this.isPasswordChecked = val
        })
        .catch(err => this.$noti.error(`Ha ocurrido un error: ${err}`))
    },
    changePassword() {
      if (this.newPasswordValue !== this.RetypePassword) {
        this.$noti.warn('Please retype Password')
        return false
      }

      this.$store.dispatch(`${this.storeType}/changePassword`,
        {
          oldPassword: this.passwordValueOld,
          newPassword: this.newPasswordValue })
        .then(() => {
          this.$noti.success('Password Changed')
          this.$emit('onPasswordChanged')
        })
        .catch(err => this.$noti.error(`Ha ocurrido un error: ${err}`))
    }
  }
}
</script>
